import icHome from '../asset/images/nav-menu-icon/home.svg';
import icTradingPlatform from '../asset/images/nav-menu-icon/trading_platform.svg';
import icUser from '../asset/images/nav-menu-icon/user.svg';
import icTrade from '../asset/images/nav-menu-icon/my_trade.svg';
import icPortfolio from '../asset/images/nav-menu-icon/portfolio.svg';
import icFunding from '../asset/images/nav-menu-icon/funding.svg';
import icEstatement from '../asset/images/nav-menu-icon/estatement.svg';
import icEforms from '../asset/images/nav-menu-icon/eforms.svg';
import icCorporate_actions from '../asset/images/nav-menu-icon/corporate_actions.svg';
import icSupport from '../asset/images/nav-menu-icon/support.svg';
import icAnnouncement from '../asset/images/nav-menu-icon/announcement.svg';
import icResearch from '../asset/images/nav-menu-icon/research.svg';

import propertyConstant from '../../constants/property'
const currentDomain = window.location.hostname;

const accessdeniedRedirect = currentDomain+"/accessdenied"

interface NavOptions {
    url?: string;
    label: string;
    icon: any;
    selected?: boolean;
    subMenu?: Array<SubMenu>;
    stayPageWhenRedirect?: boolean;
    openNewTab?: boolean;
    features?: string;
    targetName?: string;
    state?:any;
    id?:string;
    isIframe?:boolean;
}

interface SubMenu {
    url: string;
    label: string;
    selected?: boolean;
    stayPageWhenRedirect?: boolean;
    openNewTab?: boolean;
    targetName?: string;
    state?:any;
    id?:string;
    isIframe?:boolean;
}

const generateStatementType =()=>{
    let list:any = propertyConstant.statementTypeMap;
    let result = [];

    // Loop through each key in the list (statementTypeMap)
    for (let key in list) {
        if (list.hasOwnProperty(key)) {
            let prop:any = list[key];
            // Push an object with the label and url into the result array
            result.push({
                url: prop.url,
                label: prop.label
            });
        }
    }

    return result;
}

const sidebarSource: NavOptions[] = [
    {
        url: '/',
        label: 'Live Quotes',
        icon: icTradingPlatform,
        stayPageWhenRedirect:true,
        openNewTab:true,
        targetName:"mainTab",
        isIframe:true
    },
    // {
    //     url: '/trading-platform',
    //     label: 'Trading Platform',
    //     icon: icTradingPlatform
    // },
    {
        label: 'My Account',
        icon: icUser,
        targetName:"subTab",
        subMenu: [
            // {
            //     url: '/customer-profile',
            //     label: 'Customer Profile',
            //     targetName:"subTab"
            // },
            {
                url: '/account-summary',
                label: 'Account Summary',
                targetName:"subTab"
            },
            {
                url: '/due-for-force-selling',
                label: 'Due for Force Selling',
                targetName:"subTab"
            },
            {
                url: '/due-for-settlement',
                label: 'Due for Settlement',
                targetName:"subTab"
            },
            {
                url: '/remaining-purchase-contracts',
                label: 'Remaining Purchase Contracts',
                targetName:"subTab"
            },
            {
                url: '/sales-proceed-due',
                label: 'Sales Proceed Due',
                targetName:"subTab"
            },
            {
                url: '/remaining-sales-contracts',
                label: 'Remaining Sales Contracts',
                targetName:"subTab"
            },
            {
                url: '/contract',
                label: 'Contract',
                targetName:"subTab"
            },
            {
                url: '/contra',
                label: 'Contra',
                targetName:"subTab"
            },
            {
                url: '/others',
                label: 'Others',
                targetName:"subTab"
            },
            // {
            //     url: '/contract-information',
            //     label: 'Contract Information',
            //     targetName:"subTab"
            // }
        ]
    },
    {
        url: '/trade-history',
        label: 'My Trades',
        targetName:"subTab",
        icon: icTrade,
        // subMenu: [
        //     {
        //         url: '/trade-history',
        //         label: 'Trade History'
        //     }
        // ]
    },
    {
        url: '/portfolio',
        label: 'Portfolio',
        icon: icPortfolio,
        targetName:"subTab",
        id:"portfolio",
    },
    {
       // url: '/api/tool/online-payment',
        label: 'Funding',
        icon: icFunding,
        //openNewTab:true
        // targetName:"subTab",
        subMenu: [
            {
                url: '/api/tool/online-payment',
                label: 'Online Payment',
                openNewTab:true
            },
            {
                url: '/funding-withdrawal',
                label: 'Withdrawal',
                targetName:"subTab",
               // openNewTab:true
            },
        ]
    },

    {
        url: '',
        label: 'Tools',
        icon: icFunding,
        targetName:"subTab",
        id:"tools",
        subMenu: [
            {
                url: '/api/tool/tech-analyzer?redirect='+accessdeniedRedirect,
                label: 'TechAnalyzer',
                openNewTab:true,
                id:"tech_analyzer"
            },
            {
                url: '/chart-genie?redirect='+accessdeniedRedirect,
                label: 'ChartGenie',
                openNewTab:true,
                targetName:"ic",
                features:`
                        location=no,
                        toolbar=no,
                        status=no,
                        menubar=no,
                        width=${window.screen.availWidth},
                        height=${window.screen.availHeight},
                        top=0,
                        left=0
                `.replace(/\s/g, ''),
                id:"chart_genie",
            },
            {
                url: '/share-xplorer?redirect='+accessdeniedRedirect,
                label: 'ShareXplorer',
                openNewTab:true,
                id:"share_xplorer"
            },
           
            {
                url: '/stock-screener?redirect='+accessdeniedRedirect,
                label: 'Stock Screener',
                openNewTab:true,
                id:"stock_screener"
            }, 
            {
                url: '/user-guide?redirect='+accessdeniedRedirect,
                label: 'User Guide',
                openNewTab:true,
                id:"user_guide"
            }, 
        ]
    },
    {
        url: '/api/tool/reward-point?redirect='+accessdeniedRedirect,
        label: 'Rewards',
        icon: icResearch,
        openNewTab:true,
        id:"reward"
    },
    {
        // url: '/api/tool/us-report',
        label: 'Research',
        icon: icResearch,
        id:"researchs",//important
        subMenu: [
            {
                url: '/research-reports',
                label: 'Research',
                id:"research"
            },
            {
                url: '/api/tool/us-report?redirect='+accessdeniedRedirect,
                label: 'US Report',
                openNewTab:true,
                id:"us_report"
            },
            {
                url: '/research-video?redirect='+accessdeniedRedirect,
                label: 'Video',
                id:"research_video"
            }, 
       
        ]

       
    },
    {
        // url: '/eStatement',
        label: 'e-Document',
        icon: icEstatement,
        targetName:"subTab",
        subMenu: generateStatementType()
    },
    // {
    //     url: '',
    //     label: 'eForms',
    //     icon: icEforms,
    //     subMenu: [
    //         {
    //             url: '/data-correction-request-form',
    //             label: 'Data Correction Form'
    //         },
    //         {
    //             url: '/cta-ecredit-form',
    //             label: 'CTA eCREDIT Form'
    //         }
    //     ]
    // },
    // {
    //     url: '/corporate-action',
    //     label: 'Corporate Actions',
    //     icon: icCorporate_actions,
    //     targetName:"subTab",
    // },
  
    {
        url: '/announcement',
        label: 'Announcement',
        icon: icAnnouncement,
        targetName:"subTab",
    },
    // {
    //     url: 'Support',
    //     label: 'Support',
    //     icon: icSupport,
    //     targetName:"subTab",
    // }
];

export default sidebarSource;
